import { render, staticRenderFns } from "./CardProviders.vue?vue&type=template&id=5151721b&scoped=true&"
import script from "./CardProviders.vue?vue&type=script&lang=js&"
export * from "./CardProviders.vue?vue&type=script&lang=js&"
import style0 from "./CardProviders.vue?vue&type=style&index=0&id=5151721b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151721b",
  null
  
)

export default component.exports